import { useAtom, useAtomValue } from 'jotai';

import { isWebImageType } from '@/modules/annotator/annotation-utils/annotation-utils';
import { useLatestImagesV2 } from '@/react-query/useLatestImagesv2';

import {
  selectedAdjustmentTypeAtom,
  selectedImageIdAtom,
  selectedPatientIdAtom,
  selectedVisitAtom,
} from './atoms';

export const ImageCarousel = () => {
  const [selectedVisit] = useAtom(selectedVisitAtom);
  const [selectedPatientId] = useAtom(selectedPatientIdAtom);
  const [selectedImageId, setSelectedImageId] = useAtom(selectedImageIdAtom);
  const selectedAdjustmentType = useAtomValue(selectedAdjustmentTypeAtom);

  const visitId = selectedVisit ?? 0;
  const patientId = selectedPatientId ?? '';
  const { data: images, isLoading } = useLatestImagesV2({
    videaPatientId: patientId,
    estimatedVisitId: visitId.toString(),
  });

  const imageTypes =
    selectedAdjustmentType === 'Pano'
      ? ['PANORAMIC']
      : ['BITEWING', 'PERIAPICAL'];

  const imagesToDisplay =
    images?.analyses
      ?.filter((image) => imageTypes.includes(image.imageType ?? ''))
      ?.map((image) => ({
        imageId: String(image.imageId),
        imageType: image.imageType,
        thumbnailUrl: isWebImageType(image.path)
          ? image.path
          : image.originalPath,
      })) || [];

  if (imagesToDisplay.length === 0 && !isLoading) {
    return <div>No images found</div>;
  }

  return (
    <div className="vai-flex vai-gap-2 vai-overflow-x-auto vai-pb-2 vai-max-w-[1100px]">
      {imagesToDisplay.map((image) => (
        <button
          key={image.imageId}
          onClick={() => setSelectedImageId(image.imageId)}
          className={`vai-flex-shrink-0 vai-w-24 vai-h-24 vai-border-2 vai-rounded-lg vai-transition-all vai-cursor-pointer hover:vai-shadow-md ${
            selectedImageId === image.imageId
              ? 'vai-border-blue-500 vai-bg-blue-50'
              : 'vai-border-gray-300 vai-bg-white'
          }`}
        >
          {image.thumbnailUrl ? (
            <div
              className="vai-w-full vai-h-full vai-bg-gray-200 vai-rounded"
              style={{
                backgroundImage: `url(${image.thumbnailUrl})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            />
          ) : (
            <div className="vai-flex vai-items-center vai-justify-center vai-w-full vai-h-full vai-bg-gray-200 vai-rounded vai-text-xs vai-text-gray-500">
              {image.imageType}
            </div>
          )}
        </button>
      ))}
    </div>
  );
};
